import { render } from "./AgeVerification.vue?vue&type=template&id=ef524172&scoped=true"
import script from "./AgeVerification.vue?vue&type=script&lang=js"
export * from "./AgeVerification.vue?vue&type=script&lang=js"

import "./AgeVerification.vue?vue&type=style&index=0&id=ef524172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef524172"]])

export default __exports__